<template>
  <div class="container">
    <p></p>
    <div class="titulo text-center">
      <h2><strong>GESTIÓN DE TARIFAS</strong></h2>
    </div>
    <p></p>
    <div class="d-flex justify-content-between mb-3">
      <button v-if="!isFormVisible" @click="showForm" class="btn btn-success">
        <i class="bi bi-currency-dollar"></i> Agregar Tarifa
      </button>

      <input
        v-model="searchQuery"
        type="text"
        class="form-control w-25"
        placeholder="Buscar"
      />
    </div>

    <div class="table-container">
      <table class="table table-striped table-hover table-bordered">
        <thead>
          <tr>
            <th>ID</th>
            <th>Origen</th>
            <th>Destino</th>
            <th>Costo</th>
            <th>Horario</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tarifa in paginatedTarifas" :key="tarifa.Id_Tarifa">
            <td>{{ tarifa.Id_Tarifa }}</td>
            <td>{{ tarifa.Origen_Nombre }}</td>
            <td>{{ tarifa.Destino_Nombre }}</td>
            <td>{{ tarifa.Costo }}</td>
            <td>{{ tarifa.Horario }}</td>
            <td>
              <button @click="editTarifa(tarifa)" class="btn btn-link">
                <i class="bi bi-pencil-square"></i>
              </button>
              <button @click="deleteTarifa(tarifa.Id_Tarifa)" class="btn btn-link1">
                <i class="bi bi-trash-fill"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <nav aria-label="Page navigation example">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)">Anterior</button>
        </li>
        <li
          v-for="page in totalPages"
          :key="page"
          class="page-item"
          :class="{ active: page === currentPage }"
        >
          <button class="page-link" @click="changePage(page)">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)">
            Siguiente
          </button>
        </li>
      </ul>
    </nav>

    <div v-if="isFormVisible" class="form-container">
      <h3>{{ isEditing ? "Editar Tarifa" : "Agregar Tarifa" }}</h3>
      <form @submit.prevent="isEditing ? submitEditForm() : submitForm()">
        <div class="form-group">
          <label for="origen">Ubicación Origen</label>
          <select
            v-model="tarifa.Ubicacion_origen"
            id="origen"
            class="form-control"
            required
          >
            <option
              v-for="ubicacion in ubicaciones"
              :key="ubicacion.Id_ubicacion"
              :value="ubicacion.Id_ubicacion"
            >
              {{ ubicacion.Nombre }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label for="destino">Ubicación Destino</label>
          <select
            v-model="tarifa.Ubicacion_destino"
            id="destino"
            class="form-control"
            required
          >
            <option
              v-for="ubicacion in ubicaciones"
              :key="ubicacion.Id_ubicacion"
              :value="ubicacion.Id_ubicacion"
            >
              {{ ubicacion.Nombre }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label for="costo">Costo</label>
          <input
            v-model="tarifa.Costo"
            type="number"
            step="0.01"
            min="0.01"
            id="costo"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label for="horario">Horario</label>
          <input
            v-model="tarifa.Horario"
            type="time"
            id="horario"
            class="form-control"
            required
          />
        </div>
        <p></p>
        <button type="submit" class="btn btn-primary me-2">
          {{ isEditing ? "Actualizar" : "Guardar" }}
        </button>
        <button type="button" class="btn btn-secondary" @click="cancelForm">
          Cancelar
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      lista_tarifas: [],
      ubicaciones: [],
      tarifa: {
        Id_Tarifa: null,
        Ubicacion_origen: "",
        Ubicacion_destino: "",
        Costo: "",
        Horario: "",
      },
      isFormVisible: false,
      isEditing: false,
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 5,
    };
  },
  computed: {
    filteredTarifas() {
      return this.lista_tarifas.filter((tarifa) => {
        const searchString = `${tarifa.Id_Tarifa} ${tarifa.Origen_Nombre} ${tarifa.Destino_Nombre} ${tarifa.Costo} ${tarifa.Horario}`.toLowerCase();
        return searchString.includes(this.searchQuery.toLowerCase());
      });
    },
    paginatedTarifas() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredTarifas.slice(startIndex, startIndex + this.itemsPerPage);
    },
    totalPages() {
      return Math.ceil(this.filteredTarifas.length / this.itemsPerPage);
    },
  },
  methods: {
    // Obtener tarifas
    getTarifas() {
      axios
        .get(this.$backendUrl+ "/index.php/tarifas/lista_completa")
        .then((response) => {
          this.lista_tarifas = response.data;
        })
        .catch((error) => {
          Swal.fire("Error", "Error al obtener tarifas.", "error");
          console.error("Error al obtener tarifas:", error);
        });
    },

    // Obtener ubicaciones
    getUbicaciones() {
      axios
        .get(this.$backendUrl+ "/index.php/ubicaciones/lista_completa")
        .then((response) => {
          this.ubicaciones = response.data;
        })
        .catch((error) => {
          Swal.fire("Error", "Error al obtener ubicaciones.", "error");
          console.error("Error al obtener ubicaciones:", error);
        });
    },

    // Validar formulario
    validateForm() {
      if (!this.tarifa.Ubicacion_origen || !this.tarifa.Ubicacion_destino) {
        Swal.fire("Advertencia", "Debe seleccionar una ubicación para origen y destino.", "warning");
        return false;
      }
      if (this.tarifa.Ubicacion_origen === this.tarifa.Ubicacion_destino) {
        Swal.fire("Advertencia", "El origen y destino no pueden ser iguales.", "warning");
        return false;
      }
      if (!this.tarifa.Costo || this.tarifa.Costo <= 0) {
        Swal.fire("Advertencia", "El costo debe ser un número positivo.", "warning");
        return false;
      }
      if (!this.tarifa.Horario) {
        Swal.fire("Advertencia", "El horario es obligatorio.", "warning");
        return false;
      }
      return true;
    },

    // Enviar formulario para agregar tarifa
    submitForm() {
      if (this.validateForm()) {
        axios
          .post(this.$backendUrl+ "/index.php/tarifas/insertar", this.tarifa)
          .then(() => {
            this.getTarifas();
            this.cancelForm();
            Swal.fire("Éxito", "Tarifa agregada correctamente.", "success");
          })
          .catch((error) => {
            Swal.fire("Error", "Error al agregar tarifa.", "error");
            console.error("Error al agregar tarifa:", error);
          });
      }
    },

    // Enviar formulario para editar tarifa
    submitEditForm() {
      if (this.validateForm()) {
        axios
          .put(this.$backendUrl+ "/index.php/tarifas/actualizar", this.tarifa)
          .then(() => {
            this.getTarifas();
            this.cancelForm();
            Swal.fire("Éxito", "Tarifa actualizada correctamente.", "success");
          })
          .catch((error) => {
            Swal.fire("Error", "Error al editar tarifa.", "error");
            console.error("Error al editar tarifa:", error);
          });
      }
    },

    // Eliminar tarifa con confirmación
    deleteTarifa(id) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "No podrás revertir esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.$backendUrl+ "/index.php/tarifas/borrar", {
              data: { Id_Tarifa: id },
            })
            .then(() => {
              this.getTarifas();
              Swal.fire("Eliminado", "La tarifa ha sido eliminada.", "success");
            })
            .catch((error) => {
              Swal.fire("Error", "Error al eliminar tarifa.", "error");
              console.error("Error al eliminar tarifa:", error);
            });
        }
      });
    },

    // Mostrar formulario para agregar
    showForm() {
      this.isFormVisible = true;
      this.isEditing = false;
      this.resetForm();
    },

    // Mostrar formulario para editar
    editTarifa(tarifa) {
      this.isEditing = true;
      this.isFormVisible = true;
      this.tarifa = { ...tarifa };
    },

    // Cancelar formulario
    cancelForm() {
      this.isFormVisible = false;
      this.isEditing = false;
      this.resetForm();
    },

    // Resetear formulario
    resetForm() {
      this.tarifa = {
        Id_Tarifa: null,
        Ubicacion_origen: "",
        Ubicacion_destino: "",
        Costo: "",
        Horario: "",
      };
    },

    // Cambiar página
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
  mounted() {
    this.getTarifas();
    this.getUbicaciones();
  },
};
</script>


<style scoped>
.table-container {
  overflow-x: auto;
  margin-bottom: 20px;
  text-align: center;
}

.form-container {
  margin-top: 20px;
}

.pagination .page-link {
  cursor: pointer;
}

.titulo {
  background-color: #f52349;
  color: white;
  font-size: 18px;
  padding: 15px;
}

.btn-link {
  color: #2fc1f6;
  font-size: 150%;
  border: none;
}

.btn-link:hover {
  color: #ce13a2;
}

.btn-link1 {
  color: red;
  font-size: 150%;
  border: none;
}
</style>
